import { Schema, Types, model, models, Model, Document } from "mongoose";
import { NetworkSymbols } from "based-auth/networks";
import { stringifyFields } from "based-shared/utils/stringify-fields";

export interface IBoardJoinRequest extends Document {
  _id: string;
  boardId: string;
  chainId: number;
  boardTitle: string;
  requester: {
    network: NetworkSymbols;
    address: string;
  };
  status: "pending" | "approved" | "rejected" | "expired";
  message?: string;
  requestedAt: Date;
  respondedAt?: Date;
  respondedBy?: {
    network: NetworkSymbols;
    address: string;
  };
  responseMessage?: string;
  createdAt: Date;
  updatedAt: Date;
}

const boardJoinRequestSchema = new Schema<IBoardJoinRequest>(
  {
    boardId: { type: String, required: true },
    chainId: { type: Number, required: true },
    boardTitle: { type: String, required: true },
    requester: {
      network: {
        type: String,
        required: true,
      },
      address: {
        type: String,
        required: true,
      },
    },
    status: {
      type: String,
      enum: ["pending", "approved", "rejected", "expired"],
      default: "pending",
    },
    message: {
      type: String,
      required: false,
    },
    requestedAt: {
      type: Date,
      default: Date.now,
    },
    respondedAt: {
      type: Date,
      required: false,
    },
    respondedBy: {
      network: {
        type: String,
        required: false,
      },
      address: {
        type: String,
        required: false,
      },
    },
    responseMessage: {
      type: String,
      required: false,
    },
  },
  {
    timestamps: true,
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;
        delete ret.__v;

        return stringifyFields(ret);
      },
    },
  }
);

boardJoinRequestSchema.index({ boardId: 1, "requester.address": 1, "requester.network": 1 }, { unique: true });
boardJoinRequestSchema.index({ status: 1, requestedAt: 1 });
boardJoinRequestSchema.index({ "respondedBy.address": 1, "respondedBy.network": 1 });

export const BoardJoinRequestModel: Model<IBoardJoinRequest> =
  models?.BoardJoinRequest || model<IBoardJoinRequest>("BoardJoinRequest", boardJoinRequestSchema);